import { assert } from "console";
import BackButton from "../components/BackButton";
import ContinueButton from "../components/ContinueButton";
import { Countdown } from "../components/grid_fill/Countdown";
import GridManager, { GridConfig } from "../components/grid_fill/GridManager";
import { levels } from "../components/grid_fill/Levels";
import { ScoreDisplay } from "../components/grid_fill/ScoreDisplay";
import HomeButton from "../components/HomeButton";
import TryAgainButton from "../components/TryAgainButton";
import { CONST } from "../CONST";
import { MinigameScene } from "./generic/MinigameScene";
var gameanalytics = require('gameanalytics');

const minigameConfig = {
    levels: {
        spawnNewDelay: 1300, //how long we wait after completing one level to spawn another level
        startCountdownDelay: 1300, //how long we wait after spawning one level to start nextcountdown
        cameraTweenDuration: 1000,
        cameraTweenDelay: 300,
        cameraTweenHold: 300,
        cameraTween: "Back.easeInOut",
    },

    difficulty: {

        levelChances: [
            {level: {from: -1, to: 5}, easy: 1, normal: 0, hard: 0},
            {level: {from: 5, to: 10}, easy: 0.5, normal: 0.5, hard: 0},
            {level: {from: 10, to: 20}, easy: 0.2, normal: 0.6, hard: 0.2},
            {level: {from: 10, to: 20}, easy: 0.2, normal: 0.6, hard: 0.2},
            {level: {from: 20, to: 999999}, easy: 0.1, normal: 0.45, hard: 0.45},
         ],
    },

    scoring: {
        progressMultiplier: 1.08, //each level gives progressMultiplier more points
        defaultScorePerShape: 4,
        timeMultiplier: 2, 
    },

    grid: [                           //For level height:
        {yOffset: 1337, cellSize: 1337}, //0
        {yOffset: 30, cellSize: 37}, //1
        {yOffset: 30, cellSize: 37}, //2 
        {yOffset: 30, cellSize: 37}, //3 
        {yOffset: 30, cellSize: 33}, //4 
        {yOffset: 30, cellSize: 28}, //5 
        {yOffset: 30, cellSize: 24}, //6
        ],

    cameraPos: {
        y: 175, 
    }
}

export class GridFillScene extends MinigameScene {
    private difficulty  = { //CONTROLLED BY REMOTECONFIG SCENE!
        durationMultiplier: 0.96, //each level duration is durationMultiplier*previousDuration
        defaultShapeCount: 3, //if we have more shapes => larger duration

        defaultDuration: 25000, //default duration
        minimumDuration: 10000,
    }

    private isRestart = false;

    private gameplayScoreDisplay !: ScoreDisplay;
    private endScoreDisplay !: Phaser.GameObjects.Text;
    private highscoreImage !: Phaser.GameObjects.Image;
    private homeButton !: HomeButton;

    private gridManager !: GridManager;
    private countdown !: Countdown;
    private currentLevel !: GridConfig;
    private levelsCompleted !: number;


    private currentScore !: number;

    private levelQueue !: {easy: GridConfig[], normal: GridConfig[], hard: GridConfig[]};

    constructor(){
        super ({
            sceneName: CONST.SCENES.GRID_FILL,
            duration: 999999999,
            showCountdown: 0,
            showHomeButton: false,
            timeToStart: 1000,
            startScreenColor: 0x5ED3FF,
            startText: "FILL THE\nGRID!",
            startTextYOrigin: 0.45,
            startTextColor: 0x323232,
            endScreen: CONST.GRID_FILL.END,
            showSkipButton: false,
            nextScene: CONST.SCENES.BIRTH,
            endButtons: {
                normalNoSkip: {x: -426.5, y: 386, scale: 1.30},
                normalWithSkip: {x: 283, y: 386, scale: 1.30},
                skip: {x: 570, y: 386, scale: 1.30}
            },
            isArcadeMinigame: true,
          })
    }

    _init(){
        this.levelsCompleted = 0;
        this.currentScore = 0;
        this.isRestart = this.checkForRestart();

        //Reset all class variables that change during scene here (including arrays that initialize in create!)
        this.levelQueue = {easy: [], normal: [], hard: []};
        this.prepareLevelQueue();

        this.countdown = undefined;

        this.getRemoteConfig();
    }

    private getRemoteConfig(){
        let remoteConf = this.remoteConf.getConfig("gG").split(";");

        this.difficulty.durationMultiplier = parseFloat(remoteConf[0]);
        this.difficulty.defaultShapeCount = parseInt(remoteConf[1]);
        this.difficulty.defaultDuration = parseInt(remoteConf[2]) * 100;
        this.difficulty.minimumDuration = parseInt(remoteConf[3]) * 100;

        // console.log("difficulty");
        // console.log(this.difficulty);
    }

    private checkForRestart(): boolean{
        let key = this.sceneName + "restart";
        let restartInfo = this.storagePlugin.getItem(key, "");
        if (restartInfo){
            let parsed = JSON.parse(restartInfo);
            this.levelsCompleted = parsed.levels;
            this.currentScore = parsed.score;

            this.storagePlugin.removeItem(key);
            return true;
        }

        return false;
    }

    prepareLevelQueue(easy: boolean = true, normal: boolean = true, hard: boolean = true){
        if (easy) this.levelQueue.easy = Phaser.Utils.Array.Shuffle([...levels.easy]);
        if (normal) this.levelQueue.normal = Phaser.Utils.Array.Shuffle([...levels.normal]);
        if (hard) this.levelQueue.hard = Phaser.Utils.Array.Shuffle([...levels.hard]);
    }

    _preload(){
    }

    _create(){
        this.createBackground();

        this.gameplayScoreDisplay = new ScoreDisplay({scene: this, position: {x: 30, y: 10}});
        this.gameplayScoreDisplay.setScore(this.currentScore);

        this.homeButton = new HomeButton(this, 40, this.renderer.height - 40).setDepth(30).setScrollFactor(0, 0, true).setScale(0.75);
    }

    onGameStarted(){
        this.createNewGrid();
        this.createNewCountdown();
    }

    createBackground() {
        this.add.image(0, 0, CONST.GRID_FILL.BACKGROUND).setOrigin(0, 0).setDepth(0).setScrollFactor(0);

        this.add.image(this.game.renderer.width/2, minigameConfig.cameraPos.y + 5, CONST.GRID_FILL.HANDS).setDepth(10);
        this.add.image(this.game.renderer.width/2, minigameConfig.cameraPos.y, CONST.GRID_FILL.CAMERA).setDepth(9);
    } 

    //Spawns new level
    createNewGrid(){
        this.currentLevel = this.getNextLevel(this.levelsCompleted);
        this.gridManager = new GridManager(this, {x: this.game.renderer.width/2, y: minigameConfig.cameraPos.y}, this.currentLevel, minigameConfig.grid);
        this.gridManager.createGrid();
    }

    destroyCurrentGrid(){
        this.gridManager.destroy();
    }

    createNewCountdown(){
        this.countdown = new Countdown({
            scene: this,
            position: {x: this.game.renderer.width/2, y: 17},
            duration: this.getLevelDuration(this.currentLevel),
            onComplete: () => {this.triggerLose()}
        }).startCountdown();
    }
    
    getLevelDuration(level: GridConfig){
        let levelSize = level.g[0].length * level.g.length;
        let shapeCount = level.b.length;

        let shapeMultiplier = shapeCount / this.difficulty.defaultShapeCount;
        let progressMultiplier = Math.pow(this.difficulty.durationMultiplier, this.levelsCompleted);
        
        return Math.max(this.difficulty.defaultDuration * shapeMultiplier * progressMultiplier, this.difficulty.minimumDuration); 
    }   

    getNextLevel(levelsCompleted: number) : GridConfig {
        //get easy/normal/hard leveldepending on how many levels completed
        var chances = minigameConfig.difficulty.levelChances.filter( c => {return c.level.from <= levelsCompleted && c.level.to > levelsCompleted})[0];
        var rand = Math.random();

        rand -= chances.easy;
        if (rand <= 0){
            return this.getRandomLevel(this.levelQueue.easy);
        } 
        rand -= chances.normal;
        if (rand <=0){
            return this.getRandomLevel(this.levelQueue.normal);
        } 
        rand -= chances.hard;
        if (rand <= 0){
            return this.getRandomLevel(this.levelQueue.hard);
        } 

        console.log("This shouldnt happen.");
        return this.getRandomLevel(this.levelQueue.normal);
    }

    getRandomLevel(arr: GridConfig[]){
        if (arr.length < 1){
            this.prepareLevelQueue();
        }
        return arr.pop();
    }

    public onLevelCompleted(){
        this.sound.play(CONST.AUDIO.FLASH);
        setTimeout(() => {
            this.sound.play(CONST.AUDIO.WIN, {detune: this.getDetune()});
        }, 400);
        this.sendLevelAnalyticsEvent(true);

        this.levelsCompleted++;
        this.updateScore();
        this.countdown.stopCountdown();
        this.gridManager.handleLevelCompleted();

        this.animateCameraNextLevel();
        setTimeout( () => {
            this.destroyCurrentGrid();
            this.createNewGrid();
        }, minigameConfig.levels.spawnNewDelay);

        setTimeout( () => {
            this.countdown.destroy();
            this.createNewCountdown();
        }, minigameConfig.levels.spawnNewDelay + minigameConfig.levels.startCountdownDelay);    
    }

    private updateScore(){
        let baseScore = minigameConfig.scoring.defaultScorePerShape * this.currentLevel.b.length;
        let timeMultiplier = minigameConfig.scoring.timeMultiplier * this.countdown.getRemainingTimeShare();
        let progressMultiplier = Math.pow(minigameConfig.scoring.progressMultiplier, this.levelsCompleted);

        this.currentScore += Math.round(baseScore * timeMultiplier * progressMultiplier);

        this.gameplayScoreDisplay.setScore(this.currentScore);
    }

    private animateCameraNextLevel(){
        this.tweens.add({
            targets: this.cameras.main,
            scrollY: "-=480",
            ease: minigameConfig.levels.cameraTween,
            duration: minigameConfig.levels.cameraTweenDuration,
            yoyo: true,
            repeat: 0,
            delay: minigameConfig.levels.cameraTweenDelay,
            hold: minigameConfig.levels.cameraTweenHold,
        });
    }

    _update(time: number, delta: number){
        if (this.countdown){
            this.countdown.onUpdate();
        }
    }
        
    _timeout(){
       // this.loseGame();
    }

    _afterLoss(){
    }

    _afterWin(){
    }

    private triggerLose(){
        this.homeButton.setVisible(false);
        
        this.sound.play(CONST.AUDIO.LOSE, {volume: 4});

        this.sendLevelAnalyticsEvent(false);
        this.sendFinalScoreAnalyticsEvent(this.currentScore);

        this.saveAndDisplayScore();

        //Disable grid
        this.gridManager.onGameLost();

        this.loseGame(2000);
    }

    private triggerWin(){
        //trigger win after 1 second and load next scene
        this.winGame(1000);
    }

    private saveAndDisplayScore(){
        var score = this.currentScore;
        var oldHighscore = this.getHighscore();
        var isNewHighscore = score > oldHighscore;

        this.endScoreDisplay.text = score.toString();
        this.highscoreImage.setAlpha(isNewHighscore ? 1 : 0);
        let scoreLength = this.endScoreDisplay.text.length;
        this.highscoreImage.setPosition(this.highscoreImage.x + scoreLength * 17, this.highscoreImage.y - scoreLength * 1.4)
        if (isNewHighscore){
            this.setHighscore(score);
        }
    }

    protected getCustomLoseUIElements() : object[] {
        this.endScoreDisplay = this.add.text(500, 250, "123456",
                     {fontFamily: 'bloggerSans', fontSize: 35, color: "#B7A26E", align: 'center'})
                     .setAngle(-4);
        this.highscoreImage = this.add.image(503, 291.4, CONST.GRID_FILL.NEW_BEST);

        if (this.isRestart || this.registry.get(CONST.REGISTRY.ADBLOCKENABLED)){
            //Without continue button
            var backButton2 = new BackButton(CONST.SCENES.MENU, 524, 334, this, CONST.GRID_FILL.ARCADE);
            var tryAgainButton2 = new TryAgainButton(632, 329, this, CONST.GRID_FILL.TRY_AGAIN_2);
            return [backButton2, tryAgainButton2, this.endScoreDisplay, this.highscoreImage];

        } else {
            // With continue button
            var backButton = new BackButton(CONST.SCENES.MENU, 615, 365, this, CONST.GRID_FILL.BACK);
            var continueButton = new ContinueButton(627, 328, this, CONST.GRID_FILL.CONTINUE, () => {return this.getContinueData()});
            var tryAgainButton = new TryAgainButton(520, 333, this, CONST.GRID_FILL.TRY_AGAIN);
            return [backButton, continueButton, tryAgainButton, this.endScoreDisplay, this.highscoreImage];
        }
    }

    getContinueData(){
        return {levels: this.levelsCompleted, score: this.currentScore};
    }

    private sendLevelAnalyticsEvent(completed: boolean){
        let eventName = completed ? "Completed" : "Failed";
        let levelName = this.gridManager.getGridName();
        let value = completed ? this.countdown.getElapsedTime() : this.countdown.getTotalTime();
        gameanalytics.GameAnalytics.addDesignEvent(this.sceneName + ":" + levelName + ":" + eventName, Math.round(value));
        //console.log("gridfill event " + eventName + " " + levelName + " " + value);
    }
}
